import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';
import { ActionablePlaceholder } from 'ui-components/components/display-grid/actionable-placeholder';
import { Button } from 'ui-components/components/button';
import { SharedMessagesPropType } from '../../../../prop-types/intl';
import { DEFAULT_ORDERS_PAGE_URL } from '../../../../services/user-permission-service';

const messages = defineMessages({
  title: {
    description: 'rejectedFulfillmentPlaceholder.title',
    defaultMessage: 'You have no orders in <b>Rejected Fulfillment</b>',
    id: 'AUmyaZ',
  },
  titleWithStore: {
    description: 'rejectedFulfillmentPlaceholder.titleWithStore',
    defaultMessage: 'You have no orders in <b>Rejected Fulfillment</b> from {storeName}',
    id: 'j+RR82',
  },
  description: {
    description: 'rejectedFulfillmentPlaceholder.description',
    defaultMessage:
      'This section will show up again if you have fulfillments rejected by your Fulfillment Partners. <button>See orders Awaiting Shipment.</button>',
    id: 'STKnLD',
  },
});

const statusTitle = (storeName) =>
  storeName ? (
    <FormattedMessage {...messages.titleWithStore} values={{ b: (chunks) => <b>{chunks}</b>, storeName }} />
  ) : (
    <FormattedMessage {...messages.title} values={{ b: (chunks) => <b>{chunks}</b> }} />
  );

const description = (navigate) => (
  <FormattedMessage
    {...messages.description}
    values={{
      button: (chunks) => (
        <Button onClick={navigate} theme='link'>
          {chunks}
        </Button>
      ),
    }}
  />
);

const RejectedFulfillmentPlaceholder = ({ sharedMessages, hasStoreConnected, storeName, action, history }) => {
  const navigate = useCallback(() => {
    history.push(DEFAULT_ORDERS_PAGE_URL);
  }, [history]);

  return (
    <ActionablePlaceholder
      action={action}
      actionDescription={!hasStoreConnected && <FormattedMessage {...sharedMessages.actionDescription} />}
      buttonContent={!hasStoreConnected && <FormattedMessage {...sharedMessages.buttonContent} />}
      description={description(navigate)}
      title={statusTitle(storeName)}
    />
  );
};

RejectedFulfillmentPlaceholder.propTypes = {
  sharedMessages: SharedMessagesPropType.isRequired,
  hasStoreConnected: PropTypes.bool.isRequired,
  storeName: PropTypes.string,
  action: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default RejectedFulfillmentPlaceholder;
